// extracted by mini-css-extract-plugin
export default {"brand":"Brand_brand__fTE4y","content":"Brand_content__qazAa","title":"Brand_title__03s7h","logo":"Brand_logo__htQuE"};